// extracted by mini-css-extract-plugin
export default {"sider":"Editor_sider__PqPdT","link":"Editor_link__HjPTt"};